import { render, staticRenderFns } from "./ContactUsMain.vue?vue&type=template&id=df1d23a8&scoped=true&"
import script from "./ContactUsMain.vue?vue&type=script&lang=js&"
export * from "./ContactUsMain.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsMain.vue?vue&type=style&index=0&id=df1d23a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1d23a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df1d23a8')) {
      api.createRecord('df1d23a8', component.options)
    } else {
      api.reload('df1d23a8', component.options)
    }
    module.hot.accept("./ContactUsMain.vue?vue&type=template&id=df1d23a8&scoped=true&", function () {
      api.rerender('df1d23a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/ContactUs/ContactUsMain.vue"
export default component.exports